<template>
  <!-- 默认的导航栏 -->
  <div class="flex flex-col justify-center h-12">
    <div class="container mx-auto">
      <div class="grid grid-cols-3 items-center lg:grid-cols-2">
        <!-- 左侧导航栏 -->
        <div class="flex flex-row items-center lg:space-x-2 lg:col-span-1">
          <NuxtLink to="/">
            <img src="/img/logo.png" alt="" style="height: 24px; width: 24px" />
          </NuxtLink>
          <NuxtLink class="mr-10 text-xs transition duration-700 transform lg:mr-20 lg:text-base hover:scale-105" to="/"
            ><span>
              {{ getTitles }}
            </span></NuxtLink
          >
          <NuxtLink to="/promote" v-if="isDeadline">
            <div class="flex flex-row items-center pl-3">
              <el-icon size="13" color="#ef6444" class="heartbeat">
                <BellFilled />
              </el-icon>
              <span class="ml-1 text-xs font-semibold text-gray-500 transition duration-700 transform lg:text-sm hover:scale-105 hover:text-red-500">晋级名单</span>
            </div>
          </NuxtLink>
          <NuxtLink to="/attend" v-if="!isAttendHidden">
            <div class="flex flex-row items-center pl-1 sm:pl-3">
              <span class="px-2 py-1 h-6 text-xs font-semibold rounded-md duration-200 transform lg:text-sm shadow-gray-200 hover:scale-105 hover:font-bold attend hover:shadow-indigo-100"
                >授课签到</span
              >
            </div>
          </NuxtLink>
        </div>

        <div class="flex col-span-2 justify-between items-center lg:col-span-1">
          <NuxtLink to="https://apps.apple.com/cn/app/%E6%99%BA%E8%B6%A3-ai-%E5%B7%A5%E5%9D%8A/id6774125139?l=en-GB" target="_blank">
            <span
              class="px-2 py-1 w-4 h-4 text-sm font-semibold rounded-full shadow-inner duration-200 transform lg:text-base shadow-gray-100 from-light-200 hover:font-bold ai hover:shadow-indigo-100"
              >App 体验</span
            >
          </NuxtLink>
          <div v-for="(value, index) in functionArray" :key="value.title">
            <div class="transition duration-300 hover:scale-105">
              <el-dropdown v-if="value.title === '学习资源'" trigger="click" @command="handleResourceCommand">
                <span
                  class="inline-flex items-center h-6 text-xs font-normal leading-6 cursor-pointer lg:text-sm"
                  :class="currentIndexStore.getCurrentIndex === index ? ` text-black font-bold ` : ` text-gray-500 hover:text-gray-900`"
                  @click="changeSelection(index)"
                >
                  学习资源
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="docs" :icon="Document">文档学习</el-dropdown-item>
                    <el-dropdown-item command="downloads" :icon="Download">资源下载</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <NuxtLink
                v-else
                @click="changeSelection(index)"
                :class="currentIndexStore.getCurrentIndex === index ? ` text-black font-bold ` : index !== 1 ? ` text-gray-500 hover:text-gray-900` : `text-gray-500 font-semibold`"
                :to="value.linkTo"
                class="text-xs font-normal lg:text-sm"
              >
                {{ value.title }}
              </NuxtLink>
            </div>
          </div>
          <!-- <div class="flex items-center">
            <a
              href="https://apps.apple.com/cn/app/%E6%99%BA%E8%B6%A3-ai-%E5%B7%A5%E5%9D%8A/id6774125139?l=en-GB"
              target="_blank"
              class="inline-flex items-center h-6 text-xs font-normal leading-6 text-gray-500 transition duration-300 cursor-pointer lg:text-sm hover:text-gray-900 hover:scale-105"
            >
              App 下载
            </a>
          </div> -->
          <div class="flex items-center">
            <el-dropdown>
              <span class="inline-flex items-center h-6 text-xs font-normal leading-6 text-gray-500 transition duration-300 cursor-pointer lg:text-sm hover:text-gray-900 hover:scale-105">
                更多精彩
              </span>
              <template #dropdown>
                <el-dropdown-item :icon="Phone">
                  <NuxtLink to="/activity">精彩回顾</NuxtLink>
                </el-dropdown-item>
                <el-dropdown-item :icon="Link" divided>
                  <NuxtLink target="_blank" to="https://education.apple.com/learning-center/T035668A?backTo=%2Flearning-center%2FT020408A">Apple 创意活动</NuxtLink>
                </el-dropdown-item>
                <el-dropdown-item :icon="Link">
                  <NuxtLink target="_blank" to="https://developer.apple.com/cn/learn/swift-coding-club/">Swift Coding Club</NuxtLink>
                </el-dropdown-item>
                <el-dropdown-item :icon="Link">
                  <NuxtLink target="_blank" to="https://education.apple.com/learning-center">Apple 学习中心</NuxtLink>
                </el-dropdown-item>
                <el-dropdown-item :icon="Link">
                  <NuxtLink target="_blank" to="https://developer.apple.com/cn/swift-student-challenge/">Swift Student Challenge</NuxtLink>
                </el-dropdown-item>
              </template>
            </el-dropdown>
          </div>

          <button class="text-xs text-gray-600 lg:text-sm" v-if="!loginStore.isLogin" @click="showDialog">
            <span>登录/注册</span>
          </button>

          <el-dropdown v-if="loginStore.isLogin" @command="handleCommand">
            <el-avatar :size="30" :src="personalInfo.user_avatar"></el-avatar>

            <template #dropdown>
              <el-dropdown-menu class="flex flex-col items-center">
                <!-- <el-dropdown-item command="login" @click="showDialog">登录 </el-dropdown-item> -->
                <el-dropdown-item command="personalCenter">个人中心</el-dropdown-item>
                <el-dropdown-item v-if="windowWidth >= 768" command="fileUpload" @click="uploadFile">作品上传</el-dropdown-item>
                <!-- <el-dropdown-item command="outPut" :disabled="!loginStore.isLogin"
                                    @click="initCookie"><span class="text-red-400">登出</span></el-dropdown-item> -->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 登录界面 -->
    <el-dialog v-model="showLogin" title="" :width="windowWidth < 1024 ? `60%` : `30%`" :close-on-click-modal="false" append-to-body modal-class="glass-dialog">
      <div class="flex flex-col p-5 space-y-5">
        <div class="flex flex-col justify-center">
          <!-- <button class="flex flex-col justify-center items-center" @click="phoneLogin">
                        <span :class="phoneAndCode ? ` text-black` : `text-gray-400`" class="text-xl">验证码登录</span>
                        <div class="mt-2 w-full h-1 border-b-2"
                            :class="phoneAndCode ? `border-sky-400` : `border-gray-400`">
                        </div>
                    </button> -->

          <button class="flex flex-col justify-center items-center" @click="passWordLogin">
            <span :class="phoneAndPassword ? ` text-black` : `text-gray-400`" class="text-xl">密码登录</span>
          </button>
          <div class="mt-2 w-full h-1 border-b-2" :class="phoneAndPassword ? `border-sky-400` : `border-gray-400`"></div>
        </div>

        <el-form label-position="left" class="flex flex-col space-y-5" :model="userInfo" ref="ruleFormRef" :rules="rules" label-width="80px" :inline="false">
          <el-form-item label="身份码" prop="phone" class="flex w-full">
            <el-input placeholder="请输入唯一身份码" v-model="userInfo.phone"></el-input>
          </el-form-item>

          <el-form-item v-if="phoneAndCode" label=" 验证码" prop="vCode">
            <div v-if="phoneAndCode" class="flex flex-row space-x-5 w-full">
              <el-input placeholder="请输入验证码" v-model="userInfo.vCode"></el-input>
              <el-button @click="sendCode" type="primary" size="default" :disabled="!canSendCode"> {{ canSendCode ? `发送验证码` : timeCount }}</el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="phoneAndPassword" label="密码" prop="password">
            <div v-if="phoneAndPassword" class="w-full">
              <el-input show-password type="password" placeholder="请输入密码" v-model="userInfo.password"></el-input>
            </div>
          </el-form-item>

          <div class="flex flex-col w-full">
            <el-button type="primary" size="large" @click="login">登录</el-button>
          </div>
          <div v-if="phoneAndCode" class="flex text-xs text-gray-400">
            <span> <span class="text-red-400">* </span>若唯一身份码未注册则将会自动注册</span>
          </div>

          <div class="flex flex-row items-center w-full text-sm">
            <el-checkbox v-model="checkIt" label="" size="large" />
            <p>同意</p>
            <a href="#black" style="color: #8b9de3; text-decoration: none">
              <p>用户协议</p>
            </a>
            <p>和</p>
            <a href="#black" style="text-decoration: none; color: #8b9de3">
              <p>隐私政策</p>
            </a>
          </div>
        </el-form>
      </div>
      <template #footer> </template>
    </el-dialog>

    <ProjectUploadVue :showFileUpload="showFileUpload" @update:showFileUpload="showFileUpload = $event"> </ProjectUploadVue>
  </div>
</template>

<script lang="ts" setup>
import { dayjs, ElMessage } from 'element-plus'
import { BellFilled, ArrowRight, Picture, Link, Message, Phone, Document, Download } from '@element-plus/icons-vue'
import type { FormInstance, FormRules } from 'element-plus'
import ProjectUploadVue from '~/components/ProjectUpload/index.vue'

import { useLoginInfo, type LoginInfo } from '~/stores/user/loginInfo'
import { userLogin } from '~/stores/userLogin'
import { tokenName, personalInfoName, platFormName } from '~/stores/tokenName'
import { LoginAction } from '~/stores/user/loginInfo'
import { onMounted, nextTick } from 'vue'
import { useHeaderCurrentIndex } from '~/stores/header/headerCurrentIndex'
import { refreshWindowLocation } from '~/composables/refreshLocation'

let windowWidth = 0

const isDeadline = computed(() => {
  return dayjs().isBefore('2025-07-05')
})

const isAttendHidden = computed(() => {
  const now = dayjs()
  const start = dayjs('2026-07-01')
  const end = dayjs('2026-09-01')
  return (now.isSame(start, 'day') || now.isAfter(start, 'day')) && (now.isSame(end, 'day') || now.isBefore(end, 'day'))
})
onMounted(() => {
  windowWidth = window.innerWidth
})

const loginInfo = useLoginInfo()
const loginStore = userLogin()
const currentIndexStore = useHeaderCurrentIndex()

//当前点击的下标
const currentIndex = ref(currentIndexStore.getCurrentIndex)
const showLogin = ref(false)

// 获取个人信息
interface Personal {
  id: number
  user_name: string
  user_avatar: string
  user_phone: string
  user_email: string
  user_school: string
}

// 需要保存到 cookie 中的用户个人信息
const personalInfo = ref<Personal>({
  id: 0,
  user_name: '用户001',
  user_avatar: 'https://swift-blogs.oss-cn-shanghai.aliyuncs.com/avatars/png/memo_5.png',
  user_phone: '1000001',
  user_email: '123456@qq.com',
  user_school: '',
})

onMounted(async () => {
  const cookie = useCookie(personalInfoName)
  if (cookie.value) {
    if (typeof cookie.value === 'string') {
      try {
        if (process.env.NODE_ENV === 'development') {
          console.log('JSON 解析后的结果 = ', JSON.parse(cookie.value))
        }
        personalInfo.value = JSON.parse(cookie.value)
      } catch (e) {
        console.error('无法解析 JSON 字符串:', e)
      }
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.log('cookie.value 已经是对象:', cookie.value)
      }
      personalInfo.value = cookie.value
    }
  }

  const token = useCookie(tokenName)
  if (!token.value) {
    showDialog()
  }
})

const userInfo = ref({
  phone: '',
  vCode: '',
  password: '',
})

const showDialog = () => {
  windowWidth = window.innerWidth
  showLogin.value = true
}

const changeDialog = () => {
  showLogin.value = false
}

//登录的方式（唯一身份码还是验证码）
const phoneAndCode = ref(false)
const phoneAndPassword = ref(true)

const phoneLogin = () => {
  phoneAndCode.value = true
  phoneAndPassword.value = false
}

const passWordLogin = () => {
  phoneAndCode.value = false
  phoneAndPassword.value = true
}

//验证码状态
const timeCount = ref(60)
const canSendCode = ref(true)

//是否勾选了同意
const checkIt = ref(true)

//验证码倒计时
const tick = () => {
  if (timeCount.value === 0) {
    // 倒计时结束，可以在这里执行一些操作，比如通知用户
    console.log('倒计时结束!')
    canSendCode.value = true
    return
  }
  timeCount.value-- // 递减秒数
  setTimeout(() => tick(), 1000)
}

//获取到的项目 title 名字
const getTitles = ref('智惠教室学习中心')

//获取 img 的链接
const getImages = ref('')

//获取到的功能栏
const functionArray = reactive([
  {
    title: '首页',
    linkTo: '/',
  },
  // {
  //   title: '展示活动',
  //   linkTo: '/showcase',
  // },
  // {
  //   title: '精彩回顾',
  //   linkTo: '/activity',
  // },

  {
    title: '在线课程',
    linkTo: '/liveClass',
  },

  {
    title: '作品展示',
    linkTo: '/projectGallery',
  },
  {
    title: '学习资源',
    linkTo: '',
  },
])

//点击切换方法
const changeSelection = async (index: number) => {
  currentIndexStore.updateCurrentIndex(index)
  await nextTick()
  currentIndex.value = currentIndexStore.getCurrentIndex
}

const router = useRouter()

const handleResourceCommand = (command: string | number | object) => {
  if (command === 'docs') {
    router.push('/articles')
  }
  if (command === 'downloads') {
    router.push('/sourceDownload')
  }
}

//点击个人中心方法
const handleCommand = (command: string | number | object) => {
  if (command === 'personalCenter') {
    router.push('/personalCenter')
  }
}
//点击文件上传
const showFileUpload = ref(false)

const uploadFile = () => {
  showFileUpload.value = true
}

// 校验规则和校验方式
const ruleFormRef = ref<FormInstance>()

//唯一身份码校验
const phoneVerify = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入唯一身份码'))
  } else {
    if (value.length >= 8) {
      callback()
    } else {
      callback(new Error('身份码长度必须大于 8 位'))
    }
  }
}

const passwordVerify = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入密码'))
  }
}

const rules = reactive<FormRules<LoginInfo>>({
  phone: [{ validator: phoneVerify, trigger: 'blur' }],
  password: [{ validator: passwordVerify, trigger: 'blur' }],
})

//发送验证码
const sendCode = async () => {
  if (regex.test(userInfo.value.phone)) {
    loginInfo.updateInfo(userInfo.value)
    // const { hello } = await $fetch('')
    try {
      //定义请求参数
      const obj = {
        method: 'POST',
        url: RequestAPI.SEND_CODE,
        //"POST"方法传参:
        body: {
          phone: loginInfo.phone,
          platform: loginInfo.platform,
        },
        //"GET"方法URL传参:
        // query: {
        //     name:"test"
        // }
      }
      //开始请求
      let { data, status } = await postRequired(obj)
      console.log('status ===', status.value)
      if (data.value.code === 2000) {
        canSendCode.value = false
        tick()
      }
    } catch (e) {}
  }
}

/**
 * 登录
 */

async function login() {
  if (phoneAndCode.value) {
    if (userInfo.value.phone != '' && userInfo.value.vCode != '' && checkIt.value) {
      loginInfo.updateInfo(userInfo.value)
      const obj = {
        url: RequestAPI.LOGIN,
        body: {
          phone: userInfo.value.phone,
          code: userInfo.value.vCode ?? '',
          platform: loginInfo.platform,
          action: LoginAction.CODE,
        },
      }

      let { data } = await postRequired(obj)

      if (data.value.code === 2000) {
        //登录成功后进行 Token 的存储(设置过期时间为 3 天)
        const cookie = useCookie(tokenName, {
          expires: new Date(Date.now() + 60 * 60 * 24 * 3 * 1000),
        })

        const phoneCookie = useCookie('phone', {
          expires: new Date(Date.now() + 60 * 60 * 24 * 3 * 1000),
        })
        phoneCookie.value = userInfo.value.phone
        cookie.value = data.value.data.token
        showLogin.value = false
        console.log('phoneNumber === ', cookie.value)

        nextTick(async () => {
          await getPersonalInfo()
        }).then(() => {
          loginStore.isLogin = true
        })
      } else if (data.value.code === 2001) {
        ElMessage({
          message: data.value.msg,
          type: 'error',
        })
      }
    } else if (!checkIt.value) {
      ElMessage({
        message: '请阅读并同意用户协议',
        type: 'warning',
      })
    } else {
      ElMessage({
        message: '请填写唯一身份码或验证码',
        type: 'warning',
      })
    }
  } else if (phoneAndPassword.value) {
    if (userInfo.value.phone != '' && userInfo.value.password != '' && checkIt.value) {
      const loginStore = userLogin()
      loginInfo.updateInfo(userInfo.value)
      const obj = {
        url: RequestAPI.LOGIN,
        body: {
          phone: userInfo.value.phone,
          code: userInfo.value.password ?? '',
          platform: -1,
          action: LoginAction.PWD,
        },
      }

      let { data } = await postRequired(obj)

      if (data.value.code === 2000) {
        //登录成功后进行 Token 的存储(设置过期时间为 3 天)
        const cookie = useCookie(tokenName, {
          expires: new Date(Date.now() + 60 * 60 * 24 * 3 * 1000),
        })
        const phoneCookie = useCookie('phone', {
          expires: new Date(Date.now() + 60 * 60 * 24 * 3 * 1000),
        })
        // 保存 platform
        const platformCookie = useCookie(platFormName, {
          expires: new Date(Date.now() + 60 * 60 * 24 * 3 * 1000),
        })

        phoneCookie.value = userInfo.value.phone
        cookie.value = data.value.data.token
        platformCookie.value = data.value.data.platform
        nextTick(async () => {
          await getPersonalInfo()
        }).then(() => {
          console.log('刷新了页面')
          loginStore.isLogin = true
          showLogin.value = false
          refreshWindowLocation()
        })
      } else if (data.value.code === 2001) {
        ElMessage({
          message: data.value.msg,
          type: 'error',
        })
      }
    } else if (!checkIt.value) {
      ElMessage({
        message: '请阅读并同意用户协议',
        type: 'warning',
      })
    } else {
      ElMessage({
        message: '请输入唯一身份码或密码',
        type: 'warning',
      })
    }
  }
}

/**
 * 获取用户信息
 */
const getPersonalInfo = async () => {
  const obj = {
    url: RequestAPI.GET_USER_PERSONAL_INFO,
  }
  const { data } = await postRequired(obj)

  // 如果请求成功那么就在本地存储个人信息
  if (data && data.value.code === 2000) {
    const cookie = useCookie('personalInfo', {
      expires: new Date(Date.now() + 60 * 60 * 24 * 1 * 1000),
    })
    cookie.value = JSON.stringify(data.value.data)
    personalInfo.value = data.value.data
  }

  console.log('获取个人信息', data.value.data)
}
</script>

<style scoped>
.ai {
  font-weight: bold;
  color: transparent;
  background: linear-gradient(90deg, #ff007f, #ff6600, #00d9ff, #5900ff);
  background-size: 400% 400%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: flow 6s ease infinite;
}

.attend {
  font-weight: bold;
  color: transparent;
  background: linear-gradient(90deg, #ff007f, #ff6600, #00d9ff, #5900ff);
  background-size: 400% 400%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: flow 30s ease infinite;
}
@keyframes flow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.heartbeat {
  animation: heartbeat 2s ease-in-out infinite;
}

@keyframes heartbeat {
  0%,
  100% {
    transform: scale(0.9);
    opacity: 0.9;
  } /* 初始/结束状态 */
  50% {
    transform: scale(1);
    opacity: 1;
  } /* 放大并增强亮度 */
}
</style>
